module.exports = __webpack_public_path__ + "img/1备份 4.c3f3fc8a.jpg";